export default "__VITE_ASSET__DJMfK5uR__"